export enum DistillationCompositionNames {
  NAPHTHA = 'Naphtha',
  KEROSENE = 'Kerosene',
  LIGHT_GAS_OIL = 'Light Gas Oil',
  HEAVY_GAS_OIL = 'Heavy Gas Oil',
  BOTTOMS = 'Bottoms',
}
